export * from './iconify';

export * from './register-icons';
